import { AbstractControl, ValidatorFn } from '@angular/forms';

export function alphaNumeric(isCommaAllowed = false): ValidatorFn {
  const regexExpression = isCommaAllowed ? /^[^`~!@#$%®\^&*\+={}|[\]\\';"<>?/]*$/ : /^[^`~!@#$%®\^&*\+={}|[\]\\';"<>?,/]*$/;

  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!regexExpression.test(control.value)) {
      return { alphaNumeric: true };
    }

    return null;
  };
}
